module.exports = __webpack_public_path__ + "static/img/images_pianbi@2x.8480832.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/SPSR/images_pianbi@2x.png
// module id = J3tY
// module chunks = 69